import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-CvXU3iSt.mjs"));
export {
  FilePickerVue
};
